/* global jQuery */
import React, { PropTypes } from 'react'
import classnames from 'classnames'
import { Video, Bet365 } from '../../common'
import selectn from 'selectn'
import { throttle, getBallClass } from '../../../lib/utils/common'
import { bet365AffiliateCodes } from '../../../constants/bet365AffiliateCodes'

const RecentOvers = ({
  overs = []
}) => {

  const recent = []

  overs.map((over, i) => {
    recent.push(over.map((r, j) => {

      // TODO: update logic
      const isDot = r == '0'
      let circleClass = isDot ? '' : getBallClass(r)

      return <div key={i+'.'+j} className={circleClass}>{isDot ? '.' : <span className="over-score">{r}</span>}</div>
    }))
    // Add separator, If not last
    // TODO: use Array.reduce and refactor
    if(i !== overs.length-1) {
      recent.push(<div key={i+'.p'}>|</div>)
    }
  })

  return (
    <tr className="results">
        <td colSpan="12" className="recent-overs">
          <div className="recent-overs-wrapper">
            <div className="label">Recent</div>
              {recent}
          </div>
        </td>
    </tr>
  )
}

const listStatKeys = (playerType = {}) => {
  return (playerType.keys || []).map((k, i) => {
    return <th key={i} className={k.className} colSpan={k.colspan} >{k.name || k.id}</th>
  })
}

/**
 * Get video icon markup with video data
 * @param  {Object} player player details
 * @param  {Boolean} isWebView flag to determine if webview
 * @return {Object}        React element
 */
function getVideoIcon(player = {}, isWebView) {
  /*
  let videoStyles = {
    position: 'absolute',
    margin: 'auto 0'
  }
  */

  let markup = ''
  if (player.hasVideoId === true) {
    markup = (
    <div key={player.videoId} className="highlight active">
      <a data-linktype="lecvideo" className={classnames('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial' : isWebView } )} data-behavior="module_bloom" data-id={player.videoId}>
        <Video {...player.video} showCaption={true} className=""/>
      </a>
    </div>
    )
  }
  return markup
}

/**
 * Get markup for small screen video player
 * @param  {Object} player player details
 * @param  {Boolean} isWebView flag to determine if webview
 * @return {Object}        React element
 */
function getSmallScreenVideo(player = {}, isWebView) {
  return (
    <td className="col-highlight">
      <a className="long-name" href={player.href || '#'}>
        {player.fullName}
      </a>
      <a className="short-name" href={player.href || '#'}>
        {player.name}
      </a>
      { player.style ? `(${player.style})` : ''}
      {getVideoIcon(player, isWebView)}
    </td>
  )
}

/**
 * Get stats for a player
 * @param  {Object} player     playerdetails
 * @param  {Object} playerType batsman/bowler column details
 * @param  {Boolean} isWebView flag to determine if webview
 * @return {Object}            React Element (list of td's)
 *
 * As of now, FE team has chosen not to display LEC video icon at the end of row
 * So, commenting out code from here. In case, it's added back in future,
 * uncomment this section of code & add videoMarkup after {stat}.
 */
function getPlayerStat(player = {}, playerType = {}, /*isWebView*/) {
  let playerStats = player.stats || []
  // Iterate over set of player stats and build each td
  return playerStats.map((stat, j) => {


    let colmClass = selectn(`keys[${j}].className`, playerType) || ''
    let colmSpan = selectn(`keys[${j}].colspan`, playerType) || ''

    /*
    let videoMarkup = null
    if(j == playerStats.length-1) {
      if (player.hasVideoId === true) {
        videoMarkup = getVideoIcon(player, isWebView)
        //console.info('videoMarkup', videoMarkup)
      }
    }
    //console.info('stat', stat)
    */

    return(
      <td key={j} className={colmClass} colSpan={colmSpan}>
        {stat}
      </td>
    )
  })
}

const listStats = (playerType = {}, isWebView) => {
  return (playerType.list || []).map((player = {} , i) => {
    let playerRow = <tr key={i} />

    let stats = player.stats || []
    if (player.name && stats.length > 0) {
      playerRow = (
        <tr key={i}>
          {getSmallScreenVideo(player, isWebView)}
          {getPlayerStat(player, playerType, isWebView)}
        </tr>
      )
    }
    return playerRow
  })
}

/**
 * Get markup for last N overs data
 * @param  {Object} lastNForInnings processed data for last N overs
 * @return {Object}                 html markup object
 */
function getLastnMarkup( lastNForInnings = {} ) {
  let lastNMarkup = ''
  if (lastNForInnings.showModule === true) {
    lastNMarkup = `Last ${lastNForInnings.duration} Overs:<span>${lastNForInnings.runs}/${lastNForInnings.wickets}</span>`
  }
  return lastNMarkup
}

/**
 * Get markup for team reviews
 * @param  {Array}  reviews reviews data for each team
 * @param  {Number}  numColumns number of coloums
 * @return {String}         html markup
 */
function getReviewsMarkup( reviews = [], numColumns=12 ) {
  let markup = ''
  const numReviews = reviews.length
  // Proceed only if reviews are found
  if(numReviews > 0) {
    let reviewDetails = ''
    // Iterate over both teams and construct string for the reviews
    for (var i = 0; i < numReviews; i++) {
      let team = reviews[i] || {}
      let teamReviews = team.reviews || {}
      let isFirstReview = i != (numReviews - 1)
      // Get remaining, successful, unsuccessful reviews
      let remaining = teamReviews.remaining || ''
      let successful = teamReviews.successful || ''
      let unsuccessful = teamReviews.unsuccessful || ''

      // construct markup
      reviewDetails += `
        <div class="label full">${team.name}</div>
        <div class="label short">${team.abbreviation}</div> ${remaining}
        <div class="label full">(${successful} successful, ${unsuccessful} unsuccessful)${ isFirstReview ? ';' : ''}</div>
        ${isFirstReview ? '<div class="label short">|</div>' : ''}
      `
    }
    //console.info('reviewDetails', reviewDetails)
    markup = `<td colspan=${numColumns}><div class="label">Reviews remaining:</div>${reviewDetails}</td>`
  }
  return markup
}


const getColGroup = (colLen) => {
  let cols = []

  for (var i = 0; i < colLen; i++) {
    cols.push(<col key={i}/>)
  }

  return (<colgroup>{cols}</colgroup>)
}

class Innings extends React.Component {
  constructor() {
    super()
    this._initReponsive = this._initReponsive.bind(this)
  }

  static propTypes = {
    updateDeviceType: PropTypes.func
  }

  componentDidMount() {
    this.initDeviceType()
  }

  initDeviceType() {
    this._handleResize = throttle(this._initReponsive, 150).bind(this)
    try{
      jQuery(window).resize(this._handleResize)
      this._initReponsive()
    } catch(e) {
      console.error(e)
    }
  }

  componentWillUnmount() {
    jQuery(window).off('resize orientationchange', this._handleResize)
  }

  _initReponsive() {
    let currentWidth = jQuery(window).outerWidth()
    this.props.updateDeviceType && this.props.updateDeviceType(currentWidth)
  }

  render() {
    const {
      players = {
        batsmen: {},
        bowlers: {}
      },
      reviews = [],
      crr = '',
      rrr = '',
      minRemainingOvers = '',
      lastNForInnings = {},
      partnership = '',
      lastBat = '',
      fow = '',
      recentOvers = [],
      activePlayers = [],
      isSmallDevice = false,
      isWebView = false,
      generalClassCard = '',
      isLimitedOvers,
      bet365 = {},
      gameState = '',
      showFullStats = false,
      groundTime = '',
      editionDomain = ''
    } = this.props


    const affiliateCode = editionDomain === 'www.espncricinfo.com' ? bet365AffiliateCodes.nextBatsmanOut : bet365AffiliateCodes.editions
    // Flag to display component
    let showComponent = false
    // Properties which need to be checked before deciding displayability
    const props = [
      activePlayers.length
    ]
    // Iterate over props and check if data structures's lengths are not empty
    for (var i = 0; i < props.length; i++) {
      if (props[i]) {
        showComponent = true
        break
      }
    }
    
    /**
     * This is written to fix the vertical line splitter which appears on the
     * left of live career table.
     * Count the max num of stats columns (of either batsman & bowler).
     *
     */
    const batsmanKeys = selectn('batsmen.keys', players) || []
    const bowlerKeys = selectn('bowlers.keys', players) || []
    // Max number of stats columns that can appear in current players section (additional +1 for player name)
    const numColumns = Math.max(batsmanKeys.length, bowlerKeys.length) + 1
    // Number of live career columns
    const secColGrpLen = 4

    let reviewsString = getReviewsMarkup(reviews, numColumns)    
    const lastnMarkup = getLastnMarkup(lastNForInnings)
    /*
    * @TODO - remove this logic. This is written to fix the vertical line
    * splitter which appears on the left of live career table.
    *
    for (var j = colKeys.length - 1; j >= 0; j--) {
      const key = colKeys[j]
      let colspan = parseInt(key.colspan, 10)

      if (isNaN(colspan)) {
        firstColGrpLen++
      } else {
        console.info('going in else condition')
        firstColGrpLen += colspan
      }
    }
    */
    let oddType = ''
    if ( gameState == 'pregame') {
      oddType = 'odds'
    } else if ( gameState == 'live') {
      oddType = 'situation'
    }

    let printGroundTime = ''
    if(groundTime) {
      printGroundTime = `<div>Ground time: ${groundTime}</div>`
    }

    // substract the second colgroup columns. Add 1 for player name column
    let firstColGrpLen = numColumns
    if(!isSmallDevice) {
      firstColGrpLen = numColumns - secColGrpLen
    }
    let summaryTable = (
      <table cellSpacing="0" cellPadding="0" data-text-contract="Contract table" data-text-expand="Expand table" data-fix-cols="0">
        {getColGroup(firstColGrpLen, isLimitedOvers)}
        {showFullStats && getColGroup(secColGrpLen, isLimitedOvers) || null}
        <thead>
          <tr className="column-group desktop-tablet-only">
            <th colSpan={firstColGrpLen} className="u-ta-l" dangerouslySetInnerHTML={{ __html : printGroundTime }}></th>
            { showFullStats &&
              <th colSpan={secColGrpLen} className="u-ta-c">{generalClassCard}</th> || null}
          </tr>
          <tr className="results mobile-only">
            <td colSpan={ numColumns }>

              {
                crr ?
                [
                  <div key="cl" className="label">CRR:</div>,
                  <span key="cs" >{crr}</span>
                ]
                : null
              }

              {
                rrr ?
                [
                  <div key="rl" className="label">RRR:</div>,
                  <span key="rs" >{rrr}</span>
                ]
                : null
              }
              {
                // if isLimitedOvers flag is true do not show the minRemainingOvers value
                minRemainingOvers && minRemainingOvers > 0 && !isLimitedOvers ?
                [
                  <div key="rl" className="label">Min. Ov. Rem:</div>,
                  <span key="rs" >{minRemainingOvers}</span>
                ]
                : null
              }
              {
                lastnMarkup ?
                [
                  <div className="label" dangerouslySetInnerHTML={{ __html: lastnMarkup }} />,
                  <span></span>
                ]
                : null
              }
              {
                groundTime ?
                [
                  <div key="rl" className="label"> Ground Time:</div>,
                  <span key="rs" >{groundTime}</span>
                ]
                : null
              }

            </td>
          </tr>
          <tr>
            <th className="col-highlight u-ta-l">BATSMEN</th>
            {listStatKeys(players.batsmen)}
          </tr>
        </thead>
        <tbody>
          {listStats(players.batsmen, isWebView)}
        </tbody>
        <thead>
          <tr>
            <th className="col-highlight u-ta-l">BOWLERS</th>
            {listStatKeys(players.bowlers)}
          </tr>
        </thead>
        <tbody>
          {listStats(players.bowlers, isWebView)}
          { bet365.showInEdition && bet365.showInGeo &&
            <tr key="so" className="results bet">
              <td colSpan={ numColumns }>
                <Bet365 {...bet365} type={oddType} affiliateCodeOverwrite={affiliateCode} />
              </td>
            </tr>
          }
          <tr className="results">
            <td colSpan= { numColumns }>

              {
                partnership &&
                <div className="resultsItem">
                  <div key="pf" className="label full">Current Partnership :</div>
                  <div key="ps" className="label short">P'SHIP :</div>
                  <span key="psp" dangerouslySetInnerHTML={{ __html : partnership }} />
                </div> || null
              }

              {
                lastBat &&
                <div className="resultsItem">
                  <div key="lf" className="label full">Last Bat :</div>
                  <div key="ls" className="label short">L'BAT :</div>
                  <span key="lsp" dangerouslySetInnerHTML={{ __html : lastBat }} />
                </div> || null
              }

              {
                fow &&
                <div className="resultsItem">
                  <div key="ff" className="label full"> FoW :</div>
                  <div key="fs" className="label short"> FoW :</div>
                  <span key="fsp" >{fow}</span>
                </div> || null
              }

            </td>
          </tr>
          {
            reviews.length > 0 ?
            <tr className="results" dangerouslySetInnerHTML={{ __html: reviewsString }} />
            : null
          }
          {
            recentOvers.length > 0 ?
            <RecentOvers overs={recentOvers} colspan={ numColumns }/> 
            : null
          }
        </tbody>
      </table>
    )

    // if device is small, wrap the table with scrollable container
    if (isSmallDevice === true) {
      summaryTable = (
        <div className="table-wrapper">
          <div className="scrollable">
            {summaryTable}
          </div>
          <div className="shadow right"></div>
          <div className="shadow left" style={ { 'zIndex' : '10' } }></div>
        </div>
      )
    }

    const summaryContent = (
      <article className="sub-module current-inning">
        <div className="content">
            {summaryTable}
        </div>
      </article>
    )


    // Display component with data or just the parent elem based on showComponent flag
    return showComponent ? summaryContent : <article className="sub-module current-inning" />

  }
}

export default Innings



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/InningsSummary.jsx